import React from 'react';
import FactorTabLayout from '../shared/FactorTabLayout';
import { getTab } from '../config';

/**
 * Mortgage-backed securities spread analysis.
 *
 * Currently the shared factor layout with nothing extra. Add tab-specific
 * sections as children of FactorTabLayout - they stay isolated to this file.
 */
const MbsSpreadTab = ({ data, period }) => (
  <FactorTabLayout tab={getTab('mbs')} data={data} period={period} />
);

export default MbsSpreadTab;
